<template>
  <div class="popups-z"  :style="{'z-index': 15}">
    <mask-bg-swap></mask-bg-swap>
    <blackPopupMsg/>
  </div>
</template>

<script>
import maskBgSwap    from '@/components/Popups-z/maskBgSwap';
import blackPopupMsg from '@/components/Popups-z/blackPopupMsg';

export default {
  data () {
    return {

    }
  },
  components: {
    maskBgSwap,
    blackPopupMsg,
  }
}
</script>

<style lang="scss" scoped>
.popups-z{
    position: absolute;
    top: 0;
    left: 0;
    z-index: 25;
  }
</style>



// WEBPACK FOOTER //
// src/components/Popups-z.vue